import ReglasOverlay from './ReglasOverlay';
export default ReglasOverlay;